// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branchDetails_editBranchInfo__5\\+KqP {
    border-right: 1px solid #000;
}
.branchDetails_editBranchInfo__5\\+KqP .branchDetails_branch-details__IbfoP h6{
    margin-bottom: 0 !important;
    line-height: normal;
    font-weight: normal;
}
.branchDetails_editBranchInfo__5\\+KqP .branchDetails_branch-details__IbfoP span{
   margin: 0 5px;
   font-weight: 500;
   line-height: normal;
}

.branchDetails_edit-branch-details__Nfzix {
    text-align: center;
}
.branchDetails_allZipcodes__HA365 {
    text-align: right
}
.branchDetails_update-btn__nH75M {
    background: #1EE576 !important;
    color: #000 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
}
.branchDetails_update-zip-btn__eq7QP {
    background: #1EE576 !important;
    color: #000 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    padding: 1.5% 10% !important;
}
.branchDetails_update-zip-btn__eq7QP:hover{
    background-color: #1EE576
}
.branchDetails_update-zip-info__WHKmR h6{
    line-height: 2;
    margin-right: 2%;
    font-size: 15px;
}
.branchDetails_update-zip-info__WHKmR {
    margin: 1.5% 0;
}`, "",{"version":3,"sources":["webpack://./src/styles/userDetails/branchDetails.module.css"],"names":[],"mappings":"AAAA;IACI,4BAA4B;AAChC;AACA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;AACvB;AACA;GACG,aAAa;GACb,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;IACI,kBAAkB;AACtB;AACA;IACI;AACJ;AACA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;AAC/B;AACA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,4BAA4B;AAChC;AACA;IACI;AACJ;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,cAAc;AAClB","sourcesContent":[".editBranchInfo {\n    border-right: 1px solid #000;\n}\n.editBranchInfo .branch-details h6{\n    margin-bottom: 0 !important;\n    line-height: normal;\n    font-weight: normal;\n}\n.editBranchInfo .branch-details span{\n   margin: 0 5px;\n   font-weight: 500;\n   line-height: normal;\n}\n\n.edit-branch-details {\n    text-align: center;\n}\n.allZipcodes {\n    text-align: right\n}\n.update-btn {\n    background: #1EE576 !important;\n    color: #000 !important;\n    font-size: 16px !important;\n    font-weight: 500 !important;\n}\n.update-zip-btn {\n    background: #1EE576 !important;\n    color: #000 !important;\n    font-size: 16px !important;\n    font-weight: 500 !important;\n    padding: 1.5% 10% !important;\n}\n.update-zip-btn:hover{\n    background-color: #1EE576\n}\n.update-zip-info h6{\n    line-height: 2;\n    margin-right: 2%;\n    font-size: 15px;\n}\n.update-zip-info {\n    margin: 1.5% 0;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editBranchInfo": `branchDetails_editBranchInfo__5+KqP`,
	"branch-details": `branchDetails_branch-details__IbfoP`,
	"edit-branch-details": `branchDetails_edit-branch-details__Nfzix`,
	"allZipcodes": `branchDetails_allZipcodes__HA365`,
	"update-btn": `branchDetails_update-btn__nH75M`,
	"update-zip-btn": `branchDetails_update-zip-btn__eq7QP`,
	"update-zip-info": `branchDetails_update-zip-info__WHKmR`
};
export default ___CSS_LOADER_EXPORT___;
